import { ConfigurationStepId } from 'src/helpers/configurationSteps.helper';
import { BandCard } from './step-cards/BandCard';
import { BoxStyleCard } from './step-cards/BoxStyleCard';
import { FormatCard } from './step-cards/FormatCard';

export const CARDS_COMPONENTS = {
  [ConfigurationStepId.FORMAT]: FormatCard,
  [ConfigurationStepId.BAND]: BandCard,
  [ConfigurationStepId.BOX_STYLE]: BoxStyleCard,
};
